import angular from 'angular';

class ModalDeleteTranslateCtrl {
    /*@ngInject*/
    constructor(AnnouncementSvc, logger) {
        this.AnnouncementSvc = AnnouncementSvc;
        this.logger = logger;
    }

    deleteAnnouncementTranslate() {
        let vm = this;
        vm.resolve.announcement
        vm.resolve.announcement.announcementContents.splice(vm.resolve.index, 1)
        this.modalInstance.dismiss('cancel');

    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}

angular.module('app.announcement').component('modalDeleteAnnouncementTranslate', {
    templateUrl: require('./modal-delete-translate.html'),
    controller: ModalDeleteTranslateCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
